export const SMART_SORTING_ALLOWED_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'text/plain',
  'text/csv',
  'application/csv',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel.sheet.macroenabled.12',
] as const;

export const SMART_SORTING_ALLOWED_EXTENSIONS = [
  '.pdf',
  '.jpg',
  '.jpeg',
  '.png',
  '.txt',
  '.csv',
  '.xlsx',
  '.xlsm',
] as const;

export const SMART_SORTING_MAX_BYTES = 10 * 1024 * 1024;

export const SMART_SORTING_ACCEPT = {
  'application/pdf': ['.pdf'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/png': ['.png'],
  'text/plain': ['.txt'],
  'text/csv': ['.csv'],
  'application/csv': ['.csv'],
  'application/vnd.ms-excel': ['.csv'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'application/vnd.ms-excel.sheet.macroenabled.12': ['.xlsm'],
};

const MIME_TYPE_BY_EXTENSION: Readonly<Record<string, string>> = {
  '.pdf': 'application/pdf',
  '.jpg': 'image/jpeg',
  '.jpeg': 'image/jpeg',
  '.png': 'image/png',
  '.txt': 'text/plain',
  '.csv': 'text/csv',
  '.xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  '.xlsm': 'application/vnd.ms-excel.sheet.macroenabled.12',
};

function getFileExtension(filename: string): string {
  return `.${filename.split('.').pop()?.toLowerCase() ?? ''}`;
}

export function resolveSmartSortingMimeType(file: File): string {
  return MIME_TYPE_BY_EXTENSION[getFileExtension(file.name)] ?? file.type;
}

export function isSmartSortingFileAllowed(file: File): boolean {
  return getSmartSortingFileError(file) === null;
}

export function getSmartSortingFileError(file: File): string | null {
  const ext = getFileExtension(file.name);
  const extAllowed = SMART_SORTING_ALLOWED_EXTENSIONS.some(
    (allowedExtension) => allowedExtension === ext,
  );

  if (!extAllowed) {
    return `Tipo de archivo no soportado. Formatos permitidos: ${SMART_SORTING_ALLOWED_EXTENSIONS.join(', ')}`;
  }
  if (file.size > SMART_SORTING_MAX_BYTES) {
    return `El archivo es demasiado grande. Tamaño máximo: ${Math.round(SMART_SORTING_MAX_BYTES / 1024 / 1024)}MB`;
  }
  return null;
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}

export function formatConfidence(score: number | null | undefined): string {
  if (score == null) return '—';
  return `${Math.round(score * 100)}%`;
}
